import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DialogComponent } from '../views/commons/dialog/dialog.component';

@Injectable()
export class DialogService {

    constructor(private dialog: MatDialog) { }

    openSuccessDialog(data) {
        const dialogRef = this.dialog.open(DialogComponent, {
            data
        });
    }

    openErrorDialog(data) {
        const dialogRef = this.dialog.open(DialogComponent, {
            data
        });
    }

    openErrorDialogRefreshAfterClosing(data) {
            const dialogRef = this.dialog.open(DialogComponent, {
                data
            }).afterClosed().subscribe(() => {
              window.location.reload();
            });
        }

    openErrorDialogRedirectLogin(data){
        const dialogRef = this.dialog.open(DialogComponent, {
            data
        }).afterClosed().subscribe(() => {
          window.location.href = '/login';
        });
    }
}
